import {useTranslation} from "react-i18next";
import {TFunction} from "i18next";
import {Stack, Typography} from "@mui/material";
import OrderIcon from "@mui/icons-material/ShoppingCartOutlined";
import {isResourceSucceeded} from "../../utils/resourceUtils";
import {Resource} from "../../types/resource";
import {Order} from "../../types/domain/order";

export interface Props {
    orderResource: Resource<Promise<Order | undefined>>;
}

export const OrderHeader: React.FC<Props> = ({orderResource}) => {
    const {t} = useTranslation();

    return (
        <Stack direction="row" alignItems="center" justifyContent="space-between">
            <Stack direction="row" alignItems="center" gap="1.125rem">
                <OrderIcon
                    sx={{
                        color: "#404DB8",
                        width: "1.9rem",
                        height: "1.9rem",
                    }}
                    color="primary"
                />
                <Typography fontSize={30} lineHeight={1.27} fontWeight={700}>
                    {renderTitle(orderResource, t)}
                </Typography>
            </Stack>
        </Stack>
    );
};

const renderTitle = (
    orderResource: Resource<Promise<Order | undefined>>,
    t: TFunction<"translation", undefined>,
): React.ReactNode => {
    if (isResourceSucceeded(orderResource) && orderResource.data) {
        return `${t("order_page.title")} # ${orderResource.data.sid}`;
    } else {
        return null;
    }
};
